export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/environments/environment.ts